import { EntityChip } from "@circle-react-shared/EditorContentBlocks/EntityChip";
import { useTipTapEditorContext } from "@circle-react-uikit/TipTap/TipTapEditorContext";
import { useBlockEditorContext } from "@circle-react-uikit/TipTapBlockEditor/BlockEditorContext";
import { entityHref } from "@circle-react/helpers/urlHelpers/entitiesPaths";
import { useElectronAPI } from "@circle-react/hooks/utils/useElectronAPI";
import { NodeViewWrapper } from "@tiptap/react";

import { t } from "@/i18n-js/instance";
import { TippyV2 } from "@/react/components/SettingsApp/CompassCompat/Tooltip";

import { getEntityContent } from "./helpers";

interface Entity {
  comment?: string;
  id?: number;
  name: string;
  section_id?: number;
  slug?: string;
  space_slug?: string;
  type: string;
  url?: string;
}

export const EntityDisplay = ({ node }: any) => {
  const { navigateToUrl, isElectron } = useElectronAPI();
  const tiptapBlockEditorContext = useBlockEditorContext();
  const tiptapEditorContext = useTipTapEditorContext();

  const { sgidToObjectMap = {}, localSgidToObjectMap = {} } =
    tiptapEditorContext || tiptapBlockEditorContext;

  const entity: Entity =
    localSgidToObjectMap[node.attrs.sgid] || sgidToObjectMap[node.attrs.sgid];

  const redirectToEntity = (path?: string) => {
    if (!path) {
      return;
    }

    if (isElectron) {
      void navigateToUrl(path);
    } else {
      window.open(path, "_blank", "noreferrer");
    }
  };

  if (!entity) {
    return (
      <NodeViewWrapper as="span">
        <TippyV2
          interactive={false}
          content={t("unavailable_entity_message")}
          placement="top"
        >
          <span className="text-circle mx-0.5 cursor-pointer rounded-sm bg-indigo-100 px-0.5 font-medium">
            {t("unavailable_entity")}
          </span>
        </TippyV2>
      </NodeViewWrapper>
    );
  }

  const isSpaceEntity = entity.type === "space" || entity.type === "Space";

  const entityContent = getEntityContent(entity);
  const href = entityHref(entity);

  return (
    <NodeViewWrapper as="span">
      <TippyV2
        interactive={false}
        content={entityContent}
        placement="top"
        disabled={!entityContent}
      >
        <EntityChip
          onClick={() => redirectToEntity(href)}
          isSpace={isSpaceEntity}
          name={entity.name || t("tiptap.entity_untitled")}
        />
      </TippyV2>
    </NodeViewWrapper>
  );
};
